import { useEffect, useRef } from "react";
import CategoryButton from "./Button/CategoryButton";
import storageService from "../app/services/storageService";
import { ArrowBackIcon, ArrowDownIcon, ChevronArrowRight } from "./icons";

const CategoryList = ({ categories }) => {
    const sliderRef = useRef(null);

    const scrollLeft = () => {
        const { width } = sliderRef.current.children[0].getBoundingClientRect();
        sliderRef.current.scrollBy({ left: -(width + 20), behavior: "smooth" });
    };

    const scrollRight = () => {
        const { width } = sliderRef.current.children[0].getBoundingClientRect();
        sliderRef.current.scrollBy({ left: width + 20, behavior: "smooth" });
    };


    return (
        <div className="slider-container">
            <div style={{
                position: "absolute",
                display: "flex",
                zIndex: 3,
                alignItems: "center",
                top: "0px",
                bottom: "0px",
                left: "0",
                background: 'white',
                paddingRight: '5px',
                boxShadow: '20px 0px 30px white',
            }}>
                <button className="arrow left-arrow" onClick={scrollLeft}>
                    <ArrowBackIcon size={20} style={{
                        transform: "translateX(2px)",
                    }} />
                </button>
            </div>
            <div className="category-list" ref={sliderRef}>
                {categories?.map((category, i) => (
                    <CategoryButton
                        key={i}
                        id={category.id}
                        icon={storageService.publicUrl(category.image)}
                        title={category.name}
                    />
                ))}
            </div>
            <div style={{
                position: "absolute",
                display: "flex",
                zIndex: 3,
                alignItems: "center",
                top: "0px",
                bottom: "0px",
                right: "0",
                background: 'white',
                paddingLeft: '5px',
                boxShadow: '-20px 0px 30px white',
            }}>
                <button className="arrow right-arrow" onClick={scrollRight}>
                    <ArrowBackIcon size={20} style={{
                        transform: "rotate(180deg) translateX(2px)",
                    }} />
                </button>
            </div>
        </div>
    );
};

export default CategoryList;
